<template>
  <div class="popper" ref="popup" :style="{zIndex}">
    <slot></slot>
    <div v-if="arrow" data-popper-arrow class="arrow"></div>
  </div>
</template>

<script>

/**
 *
 * Componente positioniert den Inhalt immer relativ zum Parent, wo die Component eingebunden wird. Sollte auch mit <teleport> funktionieren, aber noch nicht getestet.
 *
 * Beispiel siehe AutocompleterLookup.vue
 *
 * Doku für die Options: https://popper.js.org/docs/v2/
 */
import { shallowRef, onMounted, onUpdated, nextTick } from "vue"
import { createPopper } from "@popperjs/core";

import { drawZValue } from "./bringToTop"
import getRootElementsFromComponent from "../../utils/getRootElementsFromComponent";

export default {
  props: {
    options: {
      default: {
        options: {
          modifiers: [{ name: 'offset', options: { offset: [0, 3] } }] // offset für Arrow
        }
      }
    },
    parent: { type: Object},
    arrow: Boolean
  },
  setup: function(props){
    const popup = shallowRef();
    let popperInstance = null;
    onMounted(function(){
      if(props.parent){
        const rootElements = getRootElementsFromComponent(props.parent);
        popperInstance = createPopper(rootElements[0], popup.value, props.options);
      }
      else{
        popperInstance = createPopper(popup.value.parentElement, popup.value, props.options);
      }
    });

    onUpdated(function(){
      nextTick(()=>{ popperInstance.update(); })
    });

    const zIndex = drawZValue();
    return {
      popup,
      zIndex
    }
  }
}
</script>

<style lang="scss">
.popper {
  &[data-popper-escaped] {
    visibility: hidden;
  }
      &[data-popper-placement = bottom] .arrow {
        top: 0;
        left: 0;
        margin-top: -0.71em;
        margin-left: 4;
        margin-right: 4;

        &::before {
          transform-origin: 0 100%;
        }
      }

      &[data-popper-placement = top] .arrow {
        bottom: 0;
        left: 0;
        margin-bottom: -0.71em;
        margin-left: 4;
        margin-right: 4;
        &::before {
          transform-origin: 100% 0;
        }
      };
      &[data-popper-placement=right] .arrow {
        left: 0;
        margin-left: -0.71em;
        height: 1em;
        width: 0.71em;
        margin-top: 4;
        margin-bottom: 4;
        &::before {
          transform-origin: 100% 100%
        }
      }

      &[data-popper-placement=left] .arrow {
        right: 0;
        margin-right: -0.71em;
        height: 1em;
        width: 0.71em;
        margin-top: 4;
        margin-bottom: 4;
        &::before {
          transform-origin: 0 0
        }
      }
    };
    /* stolen from https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/tooltip/tooltip.js*/
    .arrow {
      overflow: hidden;
      position: absolute;
      width: 1em;
      height: 0.71em /* = width / sqrt(2) = (length of the hypotenuse) */;
      box-sizing: border-box;

      &::before {
        content: '';
        margin: auto;
        display: block;
        width: 100%;
        height: 100%;
        background-color: white;
        transform: rotate(45deg)
      }
    }

</style>